import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const Container = styled.div`
  background-color:#EBEBEE;
  height:100%;
  user-select: none; 
  margin-top:10px;
  overflow:scroll
  
`;

export const ButtonContainer = styled.div`

  display: flex;
  justify-content: center;
  align-items: center;
  width: 450px;
  height: 41px;
  background-color: white;
  margin: 0 auto; // This centers the element horizontally
  margin-top:10px;
  border-radius:10px;
  
`;
export const SelectedButton = styled.div`

display: flex;
justify-content: center;
align-items: center;
top: 6px;
left: 6px;
border-radius: var(--br-5xs);
background-color: rgb(66, 133, 244);
width: 146px;
height: 29px;
font-weight:bold;
color: var(--color-white);
font-family: var(--font-product-sans);
cursor: pointer; /* Add this line to set the cursor to pointer */

`;
export const UnselectedButton = styled.div`

display: flex;
justify-content: center;
align-items: center;
top: 6px;
left: 6px;

width: 146px;
height: 29px;

font-family: var(--font-product-sans);
cursor: pointer; /* Add this line to set the cursor to pointer */ 
`;

export const SearchContainer = styled.div`
flex-direction:row;
display: flex;
justify-content: center;
align-items: center;
top: 6px;
left: 6px;
position: relative; /* Make sure the parent is set to a relative position */
margin-top: 2.9em;
width: 90%;
height: 29px;

font-family: var(--font-product-sans);
cursor: pointer; /* Add this line to set the cursor to pointer */ 
`;

export const Box = styled.div`

  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0; /* Position on the right side */
  font-size:14px;
  padding: 5px; /* Adjust padding as needed */
  padding-right: 25px; /* Adjust padding as needed */
`
 
export const Select = styled.select`
  padding:10px;
  font-weight: bold;
  border: none;
  background: none;
  margin-right:10px
`;

export const Search = styled.div`  
 
float:right;
border-radius: var(--br-5xs);
    background-color: white;
    width: 186px;
    height: 37px;
display:flex;
flex-direction:row;
`;
export const SearchImage = styled.img`   
padding:10px;
width: 20px;
height: 20px;
`;
export const SearchInput = styled.input`   
font-size: var(--font-size-xs);
color: var(--color-dimgray);
background-color: white;
border:none;
outline:none;
border-radius: var(--br-5xs);
`;
export const SearchBox = styled.div`  
height: 37px;
flex-shrink: 0; 
`;


export const ListBox = styled.div`   
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
  margin-top:20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;
  width: 95%;
  height: 10em;
  cursor: pointer;
  font-size: var(--font-size-sm);
  color: var(--color-gray-100);
  background:white;
  border-radius:10px; 

`
export const ListBox1 = styled.div` 
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */  
  padding-top:25px;
  margin-top:20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;
  width: 95%;
  height: 8em;
  cursor: pointer;
  font-size: var(--font-size-sm);
  color: var(--color-gray-100);
  background:white;
  border-radius:10px;


/* Media query for smaller screens */
@media only screen and (max-width: 768px) {
  .my-responsive-component {
    width: 95%; /* Make it full width on smaller screens */
    height: auto; /* Adjust height as needed */
    left: 0; /* Reset left position */
  }
`
export const ListBoxTitle = styled.div`  
padding:10px;
color: #000;
font-family: Product Sans;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: normal;
`
export const ListBoxRow = styled.div`  
display: flex;
  flex-direction: row;
  flex-wrap: wrap; 
`
export const CarBox = styled.div`  
 
  overflow: hidden;
  box-sizing: border-box; 
  padding-left:10px;
`
export const CarIcon = styled.img`  
width: 150px;

  height: 60%
  object-fit: cover;
  
`
export const CarDetailBox = styled.div`  
 
  overflow: hidden;
  box-sizing: border-box; 
  padding-left:10px;
  width:30%;
  

`
export const CarDetailGraphBox = styled.div`  
padding-left: 10%; 
  width:10%; 
`
export const CarDetailStatusBox = styled.div`  
padding-left: 1em; 
padding-right: 1em; 
  width:5em; 
  display: flex;
  flex-direction: column;
`

export const CarDetailBoxItem = styled.div`  
 display: flex;
  flex-direction: row;
  overflow: hidden;
  box-sizing: border-box; 
  padding-left:2em;
`
export const CarDetailBoxLabel = styled.div`  
 color: #7B7B7B;
font-family: Product Sans;
font-size: 0.9em;
font-style: normal;
font-weight: 400;
  line-height: 14px; /* 100% */
  overflow: hidden;
  box-sizing: border-box; 
  padding-left:10px;
  height:2em;
  width:10em;
`
export const CarDetailBoxValue = styled.div`  
 
  overflow: hidden;
  box-sizing: border-box; 
  padding-left:0px;
  color: #7B7B7B;
font-family: Product Sans;
font-size: 11px;
font-style: normal;
font-weight: 700;
line-height: 14px;
width:100%
`


export const BoxGraphContainer = styled.div`  


`;
export const GraphContainer = styled.div`  
margin:auto;
display:flex;
flex-direction:column;
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
`;
export const GraphHeading = styled.div`  
text-align:right;
letter-spacing: -0.18px;
  line-height: 14.27px;
  color: #000;
  font-family: var(--font-product-sans);
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 14.265px; /* 142.651% */
letter-spacing: -0.178px;

`;

export const Graph = styled.div`  
border-radius: 50%;
background-color: var(--color-whitesmoke-200);
width: 5.1em;
height: 5.2em;
padding:7px;

`;

export const ScanIcon = styled.div`   
width:4em;
padding-top:20px; 
padding-left:55px;
`;
export const CarHealthIcon = styled.img`   
float:right;
`;

export const Score = styled.div`   
width:100%;
padding-top:5px; 
padding-left:75px;
`;

export const Scored = styled.label`   
color: #7B7B7B;
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
`;
export const TotalScore = styled.label`   
color: #7B7B7B;
font-family: Product Sans;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
`;

export const EmptyBox = styled.div`   
display: flex;
        justify-content: center;
        align-items: center;
height: 300px; /* Set the height and width of the parent as needed */
    width: 100%;
`;

export const NoActiveScanContainer = styled.div`
  margin-top:30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px; /* Set the height as needed */
  
  
  
`;

export const NoActiveScanText = styled.div`
  text-align: center;
  font-size: 24px;
  color: #333; /* Optional: Text color */
  
`;


export const StyledNotification = styled.div`
  background-color: #4CAF50;
  color: white;
  padding: 1em;
  border-radius: 10px;
  margin-top: 1em;
  margin-bottom: 1em;
  min-width:10em;
  max-width:26em;
  font-size:11px
  
`;
         


export const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export  const OuterCircleWrapper = styled.div`
  position: relative;
  width: 70px; /* Adjust the width as needed */
  height: 70px; /* Adjust the height as needed */
`;

export  const InnerSpinner = styled.div`
  position: absolute;
  top: 20%;
  left: 25%;
  transform: translate(-50%, -50%);
  width: 36px; /* Adjust the width and height as needed */
  height: 36px;
  border-radius: 50%;
  border: 2px solid black; /* Set the color for the spinner */
  border-top: 2px solid transparent;
  animation: ${spin} 1s linear infinite;
`;